<div class="rating-stars">
  <mat-icon
    *ngFor="let item of items"
    class="star"
    [class]="item"
  >star</mat-icon>
</div>
